import { ExtendedCurrencies } from '@constants/enums';

const AVAILABLE_OPTIONS = [ExtendedCurrencies.EUR, ExtendedCurrencies.GBP];

export default {
  AVAILABLE_OPTIONS,
};
